export class ActivityTypeApiModel {
  public Id: string;
  public Name = '';
  public IconNumber: number;
  public IsDefault = false;

  public imgSrc?: string;

  public deserialize?(data: Object): ActivityTypeApiModel {
    Object.assign(this, data);

    this.imgSrc = `/assets/icons/ac-types/ac-type-${this.IconNumber}.svg`;

    return this;
  }
}
